import "console";
import { calculateGroupProfessionCosts, calculateLevelBonus, initGroup } from "../groups/group";
export const weaponTypes = [
    { id: 0, type: "Nahkampf", characterBonus: ["st", "st", "ge"], name: "1-Hand Klingen" },
    { id: 1, type: "Nahkampf", characterBonus: ["st", "st", "ge"], name: "1-Hand Schlag" },
    { id: 2, type: "Nahkampf", characterBonus: ["st", "st", "ge"], name: "2-Hand" },
    { id: 3, type: "Nahkampf", characterBonus: ["st", "st", "ge"], name: "Stangenwaffen" },
    { id: 4, type: "Fernkampf", characterBonus: ["st", "ge", "ge"], name: "Fernkampf" },
    { id: 5, type: "Fernkampf", characterBonus: ["st", "ge", "ge"], name: "Wurfwaffen" },
];
function initWeapon(professionAtribute, index) {
    const group = {
        attribute: {
            id: professionAtribute.id,
            name: professionAtribute.name
        },
        attributes: [
            {
                id: professionAtribute.id + ".0",
                name: professionAtribute.name
            }
        ]
    };
    return {
        professionAtribute: professionAtribute,
        weaponType: weaponTypes[index],
        group: initGroup(group)
    };
}
export function initWeapons(ff) {
    return ff
        .filter(ff => ff.name.includes("Waffen Gruppe"))
        .filter(ff => ff.name != "Waffen Gruppe 7")
        .map(initWeapon);
}
export function calculateWeapons(character) {
    const professionFn = calculateGroupProfessionCosts(character.profession);
    return character.weapons
        .map((weapon) => (Object.assign(Object.assign({}, weapon), { group: professionFn(weapon.group) })))
        .map(w => addWeaponCharacterBonus(w, character.characterAttributes));
}
export function addWeaponCharacterBonus(weapon, characterAttributes) {
    weapon.group.characterBonus = weapon.weaponType.characterBonus
        .map(c => characterAttributes[c])
        .reduce((a, b) => a + b);
    weapon.group = calculateLevelBonus(weapon.group);
    console.log("Weapon.addWeaponCharacterBonus", weapon);
    return weapon;
}
